export const flexMapperWithIndex: any = {
  0: 1,
  1: 1,
}

export const headerData = [
  {
    title: 'Group Id',
  },
  {
    title: 'Group Name',
  },
]

export const subGrpheaderData = [
  {
    title: 'SubGroup Name',
  },
  {
    title: 'SubGroup ID',
  },
]
